// Fallbacks that never need our server: download the recordings, email them, or call.
// Used when uploads fail, when the backend is not configured, and when the mic is unavailable.
import { mailtoHref } from '../lib/forms.js';
import { audioExt } from './mime.js';
import { fmtLength } from './dom.js';

export function downloadName(index, mimeType) {
  return `st-theresa-memory-${index}.${audioExt(mimeType)}`;
}

const clip1 = (s, n) => {
  const t = String(s || '').replace(/\s+/g, ' ').trim();
  return t.length > n ? `${t.slice(0, n - 1)}…` : t;
};

/**
 * mailto: for sending recordings by hand. Lists each answer (file name, length, question) and,
 * when the person filled in About you, their details and choices so the team has the consent.
 * clips: [{ promptId, durationSec, mimeType }]; info: { data, cfg, form }
 */
export function recordingsMailto({ to, clips, data, cfg, form }) {
  const lines = [
    'Hello,',
    '',
    'I recorded memories for the St. Theresa Oral History Project. The recording files are attached.',
    '',
    'What I answered:',
  ];
  clips.forEach((c, i) => {
    const p = data.promptById(c.promptId);
    lines.push(`${i + 1}. ${downloadName(i + 1, c.mimeType)} (${fmtLength(c.durationSec)})`);
    if (p) lines.push(`   Question: ${clip1(p.text, 140)}`);
  });
  lines.push('', ...aboutLines(cfg, form), '', '(Please attach the files you downloaded before you send this email.)');
  return mailtoHref(to, 'My St. Theresa oral history recording', lines.join('\n'));
}

/** mailto: for someone who cannot record here and will attach a voice memo instead. */
export function micMailto({ to, prompt, cfg }) {
  const lines = [
    'Hello,',
    '',
    'I could not record on the Oral History website, so I am attaching a recording I made on my phone.',
    '',
  ];
  if (prompt) lines.push(`The question I answered: ${clip1(prompt.text, 160)}`, '');
  lines.push(...aboutLines(cfg, null), '', '(Please attach your recording before you send this email.)');
  return mailtoHref(to, 'A memory for the St. Theresa Oral History Project', lines.join('\n'));
}

function labelFor(list, id) {
  const o = (list || []).find((x) => x.id === id);
  return o ? o.label : '';
}

function aboutLines(cfg, form) {
  if (form) {
    const conn = form.connection === 'other' && form.connectionOther
      ? form.connectionOther
      : labelFor(cfg.connections, form.connection);
    return [
      'About me:',
      `Name: ${form.name || ''}`,
      `Connection to St. Theresa: ${conn}`,
      `Years at St. Theresa: ${form.yearsInvolved || ''}`,
      form.email ? `Email: ${form.email}` : null,
      form.phone ? `Phone: ${form.phone}` : null,
      `Who may hear it: ${labelFor(cfg.visibility, form.visibilityChoice)}`,
      `How to name me: ${labelFor(cfg.credit, form.credit)}`,
      `I agreed: ${cfg.checkboxLabel} (consent version ${cfg.consentVersion})`,
    ].filter((x) => x != null);
  }
  const vis = (cfg.visibility || []).map((v) => v.label).join(' / ');
  return [
    'About me:',
    'Name:',
    'Connection to St. Theresa:',
    'Years at St. Theresa:',
    `Who may hear it (${vis}):`,
  ];
}
